import { useCallback, useEffect, useRef, useState } from "react";

export function useKbEditorSaveScroll(articleContent: string) {
  const [articleBodyHadBlurWithText, setArticleBodyHadBlurWithText] = useState(false);
  const saveSectionRef = useRef<HTMLDivElement>(null);

  const scrollToSaveSection = useCallback(() => {
    const el = saveSectionRef.current;
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    window.setTimeout(() => {
      el.focus({ preventScroll: true });
    }, 450);
  }, []);

  useEffect(() => {
    if (!articleContent.trim()) setArticleBodyHadBlurWithText(false);
  }, [articleContent]);

  return { articleBodyHadBlurWithText, setArticleBodyHadBlurWithText, saveSectionRef, scrollToSaveSection };
}
